export class ImageLoader {
	path: string;
	fallBackImage: string
	
	constructor(path: string, fallBackImage: string = "") {
		this.path = path;
		this.fallBackImage = fallBackImage;
	}
	Load(): Promise<HTMLImageElement>
	{
		let promise = new Promise<HTMLImageElement>((resolve,reject) => {
			const image = new Image();
			image.addEventListener("load", () => resolve(image));
			image.addEventListener("error", (e) => {
				if (this.fallBackImage != "") {
					resolve(new ImageLoader(this.fallBackImage).Load());
				}
				else {
					console.log(image.src + e);
					reject(e);
				}			
			});
			image.src = this.path;
		});
		return promise;
	}
}




